import { render, staticRenderFns } from "./index.vue?vue&type=template&id=76ef4a3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ef4a3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ef4a3b')) {
      api.createRecord('76ef4a3b', component.options)
    } else {
      api.reload('76ef4a3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=76ef4a3b&scoped=true", function () {
      api.rerender('76ef4a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/interactive/index.vue"
export default component.exports